import { alignCenter as alignCenter_1 } from './alignCenter.locstring.json';
import loc from 'owa-localize';
import RibbonButton from './RibbonButton';

import { Alignment } from 'roosterjs-editor-types';
import { setAlignment } from 'roosterjs-editor-api';

const alignCenter: RibbonButton = {
    key: 'alignCenter',
    title: () => loc(alignCenter_1),
    imageSrc: require('../svg/aligncenter.svg'),
    onExecute: (plugin, logUsage) => {
        setAlignment(plugin.getEditor(), Alignment.Center);
        logUsage('setAlignment', Alignment.Center);
    },
};

export default alignCenter;
